import isObject from "lodash/isObject";
import cloneDeep from "lodash/cloneDeep"
import { query } from "../../config/bool-const";

export default {
  methods: {
    wrapModel(model) {
      let wrapperModel = cloneDeep(query)
      Object.keys(model).forEach(key => {
        if(key in wrapperModel) return wrapperModel[key] = model[key]
        if(key in wrapperModel.queries) return wrapperModel.queries[key] = model[key]
        const targetFilterKey = Object.keys(wrapperModel.filters).find(filterKey => (key in wrapperModel.filters[filterKey].values))
        if(targetFilterKey) wrapperModel.filters[targetFilterKey].values[key] = model[key]
      })
      return wrapperModel
    },

    unwrapModel(model) {
      let unwrappedModel = {}
      Object.keys(model).forEach((key) => {
        if(isObject(model[key])) {
          if(key === 'queries') Object.keys(model[key]).forEach(queryKey =>  unwrappedModel[queryKey] = model[key][queryKey])
          if(key === 'filters') {
            Object.keys(model[key]).forEach(filterKey => {
              const values =model[key][filterKey].values
              Object.keys(values).forEach(valueKey => {
                // if filter contains objects eg. { name: '', value: 1 }, grab only the value
                if(values[valueKey] && values[valueKey].length && isObject(values[valueKey][0])) {
                  return unwrappedModel[valueKey] = Object.keys(values[valueKey]).map((key) => values[valueKey][key].value)
                }
                unwrappedModel[valueKey] = values[valueKey]
              })
            })
          }
          if (['search_type', 'biolocations', 'must_include_terms', 'should_include_terms', 'must_exclude_terms', 'include_users', 'exclude_users', 'include_influencer_group_ids', 'tags', 'searches'].indexOf(key) > -1) unwrappedModel[key] = model[key];
        }
        else {
          unwrappedModel[key] = model[key]
        }
      })
      return unwrappedModel
    },
  },
}